import { css } from '@emotion/css';

export const forgotRoot = css`
  height: 66.5rem;
  .forget-container {
    max-width: 43.8rem;
    width: calc(100% - 8rem);
    max-height: 90%;
  }
  form {
    width: 100%;
    /* width: calc(100% + 2rem); */
    /* margin-inline-start: -1rem; */
    /* margin-inline-end: -1rem; */
  }

  .successContainer {
    max-width: 64rem;
  }
`;
